import { db } from "../firebase/firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  query,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  limit,
  orderBy
} from "firebase/firestore";

export const orderService = {
  // ── Créer une commande ────────────────────────────────
  create: async (clientId, products) => {
    if (!clientId || !products?.length) {
      throw new Error("Client et produits requis.");
    }
    const orderRef = await addDoc(collection(db, "orders"), {
      clientId,
      products,
      createdAt: serverTimestamp(),
      status: "pending",
    });
    return { id: orderRef.id };
  },


  // ── Récupérer toutes les commandes ou celles d’un client ───────────────


  getAll: async () => {
    const snapshot = await getDocs(collection(db, "orders"));

    console.log("DOCS =", snapshot.docs);

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  },

  // ── Ajouter une commande avec un seul produit ───────────────
  addProduct: async (clientId, product) => {
    if (!clientId || !product) {
      throw new Error("Client et produit requis.");
    }
    const orderRef = await addDoc(collection(db, "orders"), {
      clientId,
      products: [product],
      createdAt: serverTimestamp(),
      status: "pending",
    });
    return { id: orderRef.id };
  },

  // ── Mettre à jour une commande ────────────────────────────────
  update: async (id, updates) => {
    if (!id) throw new Error("ID commande manquant.");
    await updateDoc(doc(db, "orders", id), updates);
  },

  // ── Supprimer une commande ────────────────────────────────
  delete: async (id) => {
    if (!id) throw new Error("ID commande manquant.");
    await deleteDoc(doc(db, "orders", id));
  },

  getRecentOrders: async () => {
    try {

      const q = query(collection(db, 'orders'), orderBy('createdAt', "desc"), limit(5));

      //execute la requet
      const querySnapshot = await getDocs(q);

      // Extraire les données
      const recentOrders = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      return recentOrders;
    } catch {

    }
  },

  updateStatus: async (orderId, newStatus) => {
    const orderRef = doc(db, "orders", orderId);
    await updateDoc(orderRef, {
      status: newStatus,
      updatedAt: new Date()
    });
  }

};
